import { z } from "zod";

export const GaTrackRequestBodySchema = z.object({
  clientId: z.string(),
  orgId: z.string(),
  measurementId: z.string(),
  userProperties: z
    .record(z.string(), z.record(z.literal("value"), z.string()))
    .optional(),
  events: z.record(z.string(), z.string()).array().optional(),
});

export type GaTrackRequestBodyType = z.infer<typeof GaTrackRequestBodySchema>;

export const GaTrackResponseBodySchema = z.string();

export type GaTrackResponseBodyType = z.infer<typeof GaTrackResponseBodySchema>;
